import React from 'react';
import styled from 'styled-components';
import { Block, Heading } from '@/presentation/components';
import ProcedureToggleCard from '@/presentation/reusables/ProcedureToggleCard';
import Link from '@/presentation/reusables/Link';

const ListDisc = styled.ul`
  list-style-type: disc;
  color: #161d1f;
  padding-left: 16px;
`;
const ListDecimal = styled.ul`
  list-style-type: decimal;
  color: #161d1f;
`;

interface AgreementsInfoCardProps {
  name: string;
  amount: number;
  duration: string;
  date: string;
  requirementsAuto: { text: string; valid: boolean }[];
  documentsList: string[];
  children?: React.ReactNode;
  status?: string;
  statusText?: string;
}

const AgreementsInfoCard: React.FC<AgreementsInfoCardProps> = ({
  name,
  amount,
  duration,
  date,
  requirementsAuto,
  documentsList,
  children,
  status,
  statusText
}) => (
  <ProcedureToggleCard
    name={name}
    status={status}
    statusText={statusText}
    amount={amount}
    duration={duration}
    date={date}
    buttonShowMore
  >
    <Block customized gap="12px">
      <Block>
        <Heading
          text="Porcentaje de descuento"
          level={3}
          color="var(--text-text02)"
          size={14}
          lineHeight={20}
          fontWeight="700"
          className=""
          align="flex-start"
          width="100%"
        />
        <Heading
          text="20% en tus cuotas disponibles"
          level={3}
          color="var(--text-text02)"
          size={14}
          lineHeight={20}
          fontWeight="400"
          className=""
          align="flex-start"
          width="100%"
        />
      </Block>
      <Block>
        <Heading
          text="Requisitos necesarios"
          level={3}
          color="var(--text-text02)"
          size={14}
          lineHeight={20}
          fontWeight="700"
          className=""
          align="flex-start"
          width="100%"
        />
        <Block customized padding="4px 0px 0px 16px" style={{ width: 'auto' }}>
          <ListDisc>
            {requirementsAuto && requirementsAuto.length > 0 ? (
              requirementsAuto.map((req) => <li key={req.text}>{req.text}</li>)
            ) : (
              <li>No hay requisitos disponibles.</li>
            )}
            <li>
              Si el colaborador aún no es miembro del Club Intercorp &nbsp;
              <Link
                linkName="inscribirse en la web"
                linkType="external"
                url="https://www.clubintercorp.com.pe/"
                iconName="external-link"
              />
            </li>
          </ListDisc>
        </Block>
      </Block>
      <Block>
        <Heading
          text="Documentos de sustento"
          level={3}
          color="var(--text-text02)"
          size={14}
          lineHeight={20}
          fontWeight="700"
          className=""
          align="flex-start"
          width="100%"
        />
        <Block customized padding="4px 0px 0px 16px" style={{ width: 'auto' }}>
          <ListDisc>
            {documentsList.map((doc) => (
              <li key={doc}>{doc}</li>
            ))}
          </ListDisc>
        </Block>
      </Block>
      <Block>
        <Heading
          text="Pasos a seguir"
          level={3}
          color="var(--text-text02)"
          size={14}
          lineHeight={20}
          fontWeight="700"
          className=""
          align="flex-start"
          width="100%"
        />
        <Block customized padding="4px 0px 0px 16px" style={{ width: 'auto' }}>
          <ListDecimal>
            <li>
              Selecciona el tipo de beneficiario. Luego, adjunta los documentos
              de sustento o confirma el envío de tu solicitud.
            </li>
            <li>
              Recibe la conformidad u observaciones, una vez finalizado en el
              trámite.
            </li>
          </ListDecimal>
        </Block>
      </Block>
    </Block>
    {children}
  </ProcedureToggleCard>
);

export default AgreementsInfoCard;
